

































import { Vue, Component } from 'vue-property-decorator';

import buttonGreen from '@/components/atomic/atoms/ButtonGreen.vue';

import mainAnimation from '@/assets/animations/main.svg';
import mainImage from '@/assets/images/main.svg';

@Component({
  name: 'MainSection',
  components: {
    buttonGreen,
  },
})
/**
 * @vuese
 * @group Page/MainSection
 * MainSection component
 */
export default class MainSection extends Vue {
  // [data]
  showAnimation: boolean = true;
  mainAnimation: string = mainAnimation;
  mainImage: string = mainImage;

  // [method]
  getStartedNow() {}

  // [lifecycle]
  created() {
    if (window.innerWidth <= 960) this.showAnimation = false;
  }
}
